module.exports = __webpack_public_path__ + "static/media/add.28494817.svg";